import { injectIntl } from 'react-intl';
import { formValues } from 'utils/formValues';
import SpouseInformation from './SpouseInformation';
import config from './config';
import * as validation from './validation';

export const VALIDATION = validation;
export const CONFIG = config;

export default injectIntl(formValues('isSrrsp', 'hasIncompleteInfo', 'profileConfirmed')(SpouseInformation));
